module.exports = __webpack_public_path__ + "img/sorry.2a257284.png";